import React, { useState, useEffect, useCallback } from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Grid,
  useTheme,
  Button,
  TextField,
  Autocomplete,
  Checkbox,
  Paper,
  TableBody,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  IconButton,
  Alert,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { GET, POST, PUT } from "../Generic/CrudRequest";
import Icons from "../../Utils/Icons";
import { UnfoldMore } from "@mui/icons-material";
import "./CheckList.css";
import {
  checkListAdd,
  checkListEdit,
  checklistPuntoInspeccions,
} from "./CheckListAddOrEdit";
import { useTranslation } from "react-i18next";

export default function AddOrEdiCheckList({ config }) {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(true);
  const [title, setTitle] = useState("");
  const [checkListData, setCheckListData] = useState(new checkListAdd());
  const [checklistPuntoInspeccionsData, setchecklistPuntoInspeccionsData] =
    useState(new checklistPuntoInspeccions());
  const [draggedRow, setDraggedRow] = useState(null);

  const [errors, setErrors] = useState({});
  const [rowschecklistPuntoInspeccions, setRowschecklistPuntoInspeccions] =
    useState([]);

  //checklistInspeccionGeneralTipos
  const [checklistInspeccionGeneralTip, setchecklistInspeccionGeneralTipos] =
    useState([]);
  const [selectedOption, setSelectedOption] = useState([]); // Estado para el valor seleccionado

  //PuntoInspeccions
  const [puntoInspeccion, setchePuntoInspeccions] = useState([]);
  const [selectedOptionPuntoInspeccions, setSelectedOptionPuntoInspeccions] =
    useState(null); // Estado para el valor seleccionado

  //TipoDeDato
  const [tipoDeDato, setcheTipoDeDato] = useState([]);
  const [selectedOptionTipoDeDato, setSelectedOptionTipoDeDato] =
    useState(null); // Estado para el valor seleccionado

  //checked
  const [selectedOptionCheck, setSelectedOptionCheck] = useState(false); // Estado para el valor seleccionado
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      
      if (location.pathname.includes("/Checklist/Editar")) {
        setTitle(t("checkList.addOrEdit.edit"));
        const checkListId = getcheckListIdFromPath(location.pathname);
        await getChecklistById(checkListId);
      } else {
        setTitle(t("checkList.addOrEdit.add"));
      }
      await fetchchecklistInspeccionGeneralTipos();
      await fetchPuntoInspeccions();
      await fetchTipoDeDato();
    };

    fetchData();
  }, [location.pathname, t]);

  // Efecto para recargar la página cuando cambie el idioma
  useEffect(() => {
    const handleLanguageChange = () => {
      window.location.reload();
    };

    // Escuchar cambios en el idioma
    i18n.on('languageChanged', handleLanguageChange);
  }, [i18n]);

  // Efecto para actualizar el valor seleccionado cuando cambie el idioma
  useEffect(() => {
    if (selectedOption && selectedOption.length > 0) {
      // Buscar las opciones actualizadas en el nuevo idioma
      const updatedSelectedOption = selectedOption.map(selected => {
        const updatedOption = checklistInspeccionGeneralTip.find(
          option => option.idInspeccionGeneralTipo === selected.idInspeccionGeneralTipo
        );
        return updatedOption || selected;
      });
      
      setSelectedOption(updatedSelectedOption);
    }
  }, [i18n.language, checklistInspeccionGeneralTip]);

  // Efecto para actualizar las descripciones en la tabla cuando cambie el idioma
  useEffect(() => {
    if (rowschecklistPuntoInspeccions.length > 0 && puntoInspeccion.length > 0 && tipoDeDato.length > 0) {
      const updatedRows = rowschecklistPuntoInspeccions.map(row => {
        const updatedRow = { ...row };
        
        // Actualizar descripción del punto de inspección
        if (row.idPuntoInspeccion) {
          const puntoInspeccionEncontrado = puntoInspeccion.find(
            punto => punto.idPuntoInspeccion === row.idPuntoInspeccion
          );
          if (puntoInspeccionEncontrado) {
            const currentLang = i18n.language;
            updatedRow.descripcionPuntoInspeccion = currentLang === "en" 
              ? puntoInspeccionEncontrado.descripcionIngles 
              : puntoInspeccionEncontrado.descripcion;
          }
        }
        
        // Actualizar descripción del tipo de dato
        if (row.idTipoValor) {
          const tipoDatoEncontrado = tipoDeDato.find(
            tipo => tipo.idTipoValor === row.idTipoValor
          );
          if (tipoDatoEncontrado) {
            // El API ya devuelve la descripción en el idioma correcto
            updatedRow.descripcionTipoDato = tipoDatoEncontrado.descripcion;
          }
        }
        
        return updatedRow;
      });
      
      setRowschecklistPuntoInspeccions(updatedRows);
    }
  }, [i18n.language, puntoInspeccion, tipoDeDato, rowschecklistPuntoInspeccions]);

  // #region checklistInspeccionGeneralTipos
  const fetchchecklistInspeccionGeneralTipos = async () => {
    const checklistInspeccionGeneralTipo = await GET(
      `${config.url}/api/InspectionGeneralType/`
    );
    setchecklistInspeccionGeneralTipos(checklistInspeccionGeneralTipo);
  };

  const isOptionEqualToValue = (option, value) => {
    return option.idInspeccionGeneralTipo === value.idInspeccionGeneralTipo; // Comparar el valor de la opción con el valor seleccionado
  };

  const getOptionLabel = useCallback((option) => {
    // El API ya devuelve la descripción en el idioma correspondiente
    return option ? option.descripcion || "" : "";
  }, []);

  const handleChangechecklistInspeccionGeneralTipos = (
    event,
    selectedOption
  ) => {
    setCheckListData((prevState) => ({
      ...prevState,
      checkListInspeccionGeneralTipos: selectedOption,
    }));

    setSelectedOption(selectedOption); // Actualizar el valor seleccionado
  };
  //#endregion

  // #region PuntoInspeccions
  const fetchPuntoInspeccions = async () => {
    const puntoInspeccion = await GET(`${config.url}/api/InpectionPoint/`);
    // console.log(puntoInspeccion)
    setchePuntoInspeccions(puntoInspeccion);
  };

  const isOptionEqualToValuePuntoInspeccions = (option, value) => {
    return option.idPuntoInspeccion === value.idPuntoInspeccion; // Comparar el valor de la opción con el valor seleccionado
  };

  const getOptionLabelPuntoInspeccions = useCallback((option) => {
    // Usar el campo correcto según el idioma actual
    const currentLang = i18n.language;
    const description = currentLang === "en" ? option.descripcionIngles : option.descripcion;
    return option ? description || "" : "";
  }, [i18n.language]);

  const handleChangePuntoInspeccions = (
    event,
    selectedOptionPuntoInspeccion
  ) => {
    if (selectedOptionPuntoInspeccion !== null) {
      // Guardar el campo correcto según el idioma actual
      const currentLang = i18n.language;
      const description = currentLang === "en" ? selectedOptionPuntoInspeccion.descripcionIngles : selectedOptionPuntoInspeccion.descripcion;
      
      setchecklistPuntoInspeccionsData((prevState) => ({
        ...prevState,
        idPuntoInspeccion: selectedOptionPuntoInspeccion.idPuntoInspeccion,
        descripcionPuntoInspeccion: description,
      }));
    }
    setSelectedOptionPuntoInspeccions(selectedOptionPuntoInspeccion); // Actualizar el valor seleccionado
  };
  //#endregion

  // #region TipoDeDato
  const fetchTipoDeDato = async () => {
    const puntoInspeccion = await GET(`${config.url}/api/TipoValor/`);
    setcheTipoDeDato(puntoInspeccion);
  };

  const isOptionEqualToValueTipoDeDato = (option, value) => {
    return option.idTipoValor === value.idTipoValor; // Comparar el valor de la opción con el valor seleccionado
  };

  const getOptionLabelTipoDeDato = (option) => {
    // El API ya devuelve la descripción en el idioma correspondiente
    return option ? option.descripcion || "" : "";
  };

  const handleChangeTipoDeDato = (event, selectedOptionTipoDeDato) => {
    if (selectedOptionTipoDeDato !== null) {
      // El API ya devuelve la descripción en el idioma correspondiente
      setchecklistPuntoInspeccionsData((prevState) => ({
        ...prevState,
        idTipoValor: selectedOptionTipoDeDato.idTipoValor,
        descripcionTipoDato: selectedOptionTipoDeDato.descripcion,
      }));
    }
    setSelectedOptionTipoDeDato(selectedOptionTipoDeDato); // Actualizar el valor seleccionado
  };
  //#endregion

  //#region Checkbox
  const handleCheckboxChange = (event, checked) => {
    setchecklistPuntoInspeccionsData((prevState) => ({
      ...prevState,
      requiereImagen: checked,
    }));
    setSelectedOptionCheck(checked);
  };

  //#endregion

  //#region Agregar
  const handleChangeAgregar = (event, value) => {
    const requiredFields = ["idPuntoInspeccion", "idTipoValor"];
    const newErrors = {};

    requiredFields.forEach((field) => {
      const fieldValue = getFieldByPath(checklistPuntoInspeccionsData, field);
      if (!fieldValue || fieldValue === "") {
        newErrors[field] = t("checkList.addOrEdit.requiredField");
      }
    });

    if (checklistPuntoInspeccionsData.idPuntoInspeccion !== null) {
      const elementoEncontrado = buscarElementoPorId(
        checklistPuntoInspeccionsData.idPuntoInspeccion
      );
      if (elementoEncontrado) {
        newErrors["idPuntoInspeccion"] = t("checkList.addOrEdit.duplicateInspectionPoint");
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (checklistPuntoInspeccionsData.idPuntoInspeccion !== null) {
      //obtenemos el index mas alto
      const highestIndex = rowschecklistPuntoInspeccions.reduce(
        (maxIndex, currentItem) => {
          return currentItem.orden > maxIndex ? currentItem.orden : maxIndex;
        },
        0
      );

      //agreamos el index uno mas
      checklistPuntoInspeccionsData.orden = highestIndex + 1;
      //se agrega a la tabla
      setRowschecklistPuntoInspeccions([
        ...rowschecklistPuntoInspeccions,
        checklistPuntoInspeccionsData,
      ]);
    }

    setchecklistPuntoInspeccionsData(new checklistPuntoInspeccions());
    setSelectedOptionPuntoInspeccions(null);
    setSelectedOptionTipoDeDato(null);
    setSelectedOptionCheck(false);
    setErrors(newErrors);
  };

  //#endregion

  const handleRemoveUnit = (index) => {
    const updatedRows = [...rowschecklistPuntoInspeccions];
    updatedRows.splice(index, 1);

    updatedRows.forEach((row, idx) => {
      row.orden = idx + 1;
    });

    setRowschecklistPuntoInspeccions(updatedRows);
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("index", index);
    setDraggedRow(index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetIndex) => {
    const draggedIndex = e.dataTransfer.getData("index");
    const newData = [...rowschecklistPuntoInspeccions];
    const movedRow = newData.splice(draggedIndex, 1)[0];
    newData.splice(targetIndex, 0, movedRow);

    newData.forEach((row, idx) => {
      row.orden = idx + 1;
    });
    setRowschecklistPuntoInspeccions(newData);
  };

  const handleDragEnd = () => {
    setDraggedRow(null);
  };

  const getcheckListIdFromPath = (pathname) => {
    const parts = pathname.split("/");
    return parts[parts.length - 1];
  };

  const getChecklistById = async (checkListId) => {
    const dataCheckList = await GET(
      `${config.url}/api/Checklist/${checkListId}`
    );
    const updateDataCheckLis = new checkListEdit(dataCheckList);

    await setCheckListData(updateDataCheckLis);
    await setSelectedOption(updateDataCheckLis.checkListInspeccionGeneralTipos);

    //si no tiene orden se les agrega por default
    updateDataCheckLis.checklistPuntoInspeccions.forEach((row, idx) => {
      if (row.orden == null) {
        row.orden = idx + 1;
      }
    });

    await setRowschecklistPuntoInspeccions(
      updateDataCheckLis.checklistPuntoInspeccions
    );
  };

  const addCheckList = async () => {
    const requiredFields = [
      "descripcion",
      "descripcionIngles",
      "descripcionTexto",
      "descripcionTextoIngles",
      "checkListInspeccionGeneralTipos",
    ];
    const newErrors = {};

    requiredFields.forEach((field) => {
      const fieldValue = getFieldByPath(checkListData, field);
      if (!fieldValue || fieldValue === "" || fieldValue.length === 0) {
        newErrors[field] = t("checkList.addOrEdit.requiredField");
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Preparar los datos para enviar
    const dataToSend = {
      ...checkListData,
      checklistPuntoInspeccions: rowschecklistPuntoInspeccions
    };

    // Convertir checkListInspeccionGeneralTipos al formato que espera el API
    if (dataToSend.checkListInspeccionGeneralTipos && Array.isArray(dataToSend.checkListInspeccionGeneralTipos)) {
      dataToSend.checkListInspeccionGeneralTipos = dataToSend.checkListInspeccionGeneralTipos.map(tipo => {
        if (typeof tipo === 'object') {
          return {
            idCheckListInspeccionGeneralTipo: 0, // Nuevo registro
            idInspeccionGeneralTipo: tipo.idInspeccionGeneralTipo,
            descripcion: tipo.descripcion || tipo.descripcionIngles,
            estatus: true
          };
        }
        return tipo;
      });
    }

    // Asegurar que los campos de checklistPuntoInspeccions tengan los valores correctos
    dataToSend.checklistPuntoInspeccions = dataToSend.checklistPuntoInspeccions.map(item => ({
      ...item,
      idCheckList: dataToSend.idCheckList || null,
      idCheckListPuntoInspeccion: (item.idCheckListPuntoInspeccion && item.idCheckListPuntoInspeccion > 0) || (item.idChecklistPuntoInspeccion && item.idChecklistPuntoInspeccion > 0) ? (item.idCheckListPuntoInspeccion || item.idChecklistPuntoInspeccion) : 0,
      idPuntoInspeccion: item.idPuntoInspeccion,
      descripcionPuntoInspeccion: item.descripcionPuntoInspeccion,
      idTipoValor: item.idTipoValor,
      descripcionTipoDato: item.descripcionTipoDato,
      orden: item.orden,
      requiereImagen: item.requiereImagen,
      estatus: true,
      descripcionInglesPuntoInspeccion: item.descripcionPuntoInspeccion, // Por ahora usar la misma descripción
      descripcionInglesTipoDato: item.descripcionTipoDato // Por ahora usar la misma descripción
    }));

    try {
      await POST(`${config.url}/api/Checklist`, dataToSend);
      navigate("/CheckList");
    } catch (error) {
      // Mostrar más detalles del error si están disponibles
      if (error.response && error.response.data) {
        setErrorMessage(`Error al guardar el checklist: ${JSON.stringify(error.response.data)}`);
      } else {
        setErrorMessage("Error al guardar el checklist. Verifica que todos los campos estén completos.");
      }
      setShowError(true);
    }
  };

  const editCheckList = async () => {
    const requiredFields = [
      "descripcion",
      "descripcionIngles",
      "descripcionTexto",
      "descripcionTextoIngles",
      "checkListInspeccionGeneralTipos",
    ];
    const newErrors = {};

    requiredFields.forEach((field) => {
      const fieldValue = getFieldByPath(checkListData, field);
      if (!fieldValue || fieldValue === "" || fieldValue.length === 0) {
        newErrors[field] = t("checkList.addOrEdit.requiredField");
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Preparar los datos para enviar
    const dataToSend = {
      ...checkListData,
      checklistPuntoInspeccions: rowschecklistPuntoInspeccions
    };

    // Convertir checkListInspeccionGeneralTipos al formato que espera el API
    if (dataToSend.checkListInspeccionGeneralTipos && Array.isArray(dataToSend.checkListInspeccionGeneralTipos)) {
      dataToSend.checkListInspeccionGeneralTipos = dataToSend.checkListInspeccionGeneralTipos.map(tipo => {
        if (typeof tipo === 'object') {
          return {
            idCheckListInspeccionGeneralTipo: tipo.idCheckListInspeccionGeneralTipo || 0,
            idInspeccionGeneralTipo: tipo.idInspeccionGeneralTipo,
            descripcion: tipo.descripcion || tipo.descripcionIngles,
            estatus: true
          };
        }
        return tipo;
      });
    }

    // Asegurar que los campos de checklistPuntoInspeccions preserven los IDs existentes
    dataToSend.checklistPuntoInspeccions = dataToSend.checklistPuntoInspeccions.map(item => ({
      ...item,
      idCheckList: dataToSend.idCheckList,
      idCheckListPuntoInspeccion: (item.idCheckListPuntoInspeccion && item.idCheckListPuntoInspeccion > 0) || (item.idChecklistPuntoInspeccion && item.idChecklistPuntoInspeccion > 0) ? (item.idCheckListPuntoInspeccion || item.idChecklistPuntoInspeccion) : 0,
      idPuntoInspeccion: item.idPuntoInspeccion,
      descripcionPuntoInspeccion: item.descripcionPuntoInspeccion,
      idTipoValor: item.idTipoValor,
      descripcionTipoDato: item.descripcionTipoDato,
      orden: item.orden,
      requiereImagen: item.requiereImagen,
      estatus: true,
      descripcionInglesPuntoInspeccion: item.descripcionPuntoInspeccion, // Por ahora usar la misma descripción
      descripcionInglesTipoDato: item.descripcionTipoDato // Por ahora usar la misma descripción
    }));

    try {
      await PUT(`${config.url}/api/Checklist`, dataToSend);
      navigate("/CheckList");
    } catch (error) {
      // Mostrar más detalles del error si están disponibles
      if (error.response && error.response.data) {
        setErrorMessage(`Error al actualizar el checklist: ${JSON.stringify(error.response.data)}`);
      } else {
        setErrorMessage("Error al actualizar el checklist. Verifica que todos los campos estén completos.");
      }
      setShowError(true);
    }
  };

  const getFieldByPath = (object, path) => {
    const pathArray = path.split(".");
    let value = object;
    for (const prop of pathArray) {
      value = value[prop];
      if (value === undefined) break;
    }
    return value;
  };

  const handleSubmit = async () => {
    if (title === t("checkList.addOrEdit.add")) {
      await addCheckList();
    } else if (title === t("checkList.addOrEdit.edit")) {
      await editCheckList();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCheckListData({
      ...checkListData,
      [name]: value,
    });
  };

  // Función para buscar un elemento por ID
  const buscarElementoPorId = (id) => {
    // Utilizando el método find para encontrar el elemento con el ID proporcionado
    return rowschecklistPuntoInspeccions.find(
      (item) => item.idPuntoInspeccion === id
    );
  };

  return (
    <>
      {showError && (
        <Alert 
          severity="error" 
          onClose={() => setShowError(false)}
          sx={{ marginBottom: 2 }}
        >
          {errorMessage}
        </Alert>
      )}
      <Card
        variant="outlined"
        sx={{
          overflow: "hidden",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: 2,
        }}
      >
      <CardContent>
        <CardContent sx={{ display: "flex", alignItems: "center" }}>
          <Icons
            iconName="ArrowBack"
            fontSize="large"
            style={{
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              marginRight: 20,
            }}
            to="/CheckList"
            tooltip={t("buttons.back")}
          />
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {title} {t("checkList.title")}
          </Typography>
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <Card
          variant="outlined"
          sx={{
            overflow: "hidden",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            marginTop: 2,
          }}
        >
          <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
            <Typography
              variant="h5"
              sx={{
                flex: "1",
                color: theme.palette.primary.main,
              }}
            >
              {t("checkList.addOrEdit.checkListInfo")}
            </Typography>
            <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  id="descripcion"
                  name="descripcion"
                  label={t("checkList.name")}
                  value={checkListData.descripcion}
                  variant="standard"
                  onChange={handleChange}
                  error={!!errors.descripcion}
                  helperText={errors.descripcion}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  id="descripcionIngles"
                  name="descripcionIngles"
                  label={t("checkList.nameEn")}
                  value={checkListData.descripcionIngles}
                  variant="standard"
                  onChange={handleChange}
                  error={!!errors.descripcionIngles}
                  helperText={errors.descripcionIngles}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  id="descripcionTexto"
                  name="descripcionTexto"
                  label={t("checkList.description")}
                  value={checkListData.descripcionTexto || ""}
                  variant="standard"
                  onChange={handleChange}
                  error={!!errors.descripcionTexto}
                  helperText={errors.descripcionTexto}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  id="descripcionTextoIngles"
                  name="descripcionTextoIngles"
                  label={t("checkList.descriptionEn")}
                  value={checkListData.descripcionTextoIngles || ""}
                  variant="standard"
                  onChange={handleChange}
                  error={!!errors.descripcionTextoIngles}
                  helperText={errors.descripcionTextoIngles}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Autocomplete
                  multiple
                  options={checklistInspeccionGeneralTip}
                  getOptionLabel={getOptionLabel}
                  value={selectedOption}
                  isOptionEqualToValue={isOptionEqualToValue}
                  onChange={handleChangechecklistInspeccionGeneralTipos}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("checkList.inspectionTypes")}
                      variant="standard"
                      error={!!errors.checkListInspeccionGeneralTipos}
                      helperText={errors.checkListInspeccionGeneralTipos}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card
          variant="outlined"
          sx={{
            overflow: "hidden",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            marginTop: 2,
          }}
        >
          <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
            <Typography
              variant="h5"
              sx={{
                flex: "1",
                color: theme.palette.primary.main,
              }}
            >
              {t("checkList.addOrEdit.checkList")}
            </Typography>
            <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  options={puntoInspeccion}
                  getOptionLabel={getOptionLabelPuntoInspeccions}
                  value={selectedOptionPuntoInspeccions}
                  isOptionEqualToValue={isOptionEqualToValuePuntoInspeccions}
                  onChange={handleChangePuntoInspeccions}
                  renderOption={(props, option) => (
                    <li {...props} key={option.idPuntoInspeccion}>
                      {getOptionLabelPuntoInspeccions(option)}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("checkList.addOrEdit.inspectionPoints")}
                      variant="standard"
                      error={!!errors.idPuntoInspeccion}
                      helperText={errors.idPuntoInspeccion}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  options={tipoDeDato}
                  getOptionLabel={getOptionLabelTipoDeDato}
                  value={selectedOptionTipoDeDato}
                  isOptionEqualToValue={isOptionEqualToValueTipoDeDato}
                  onChange={handleChangeTipoDeDato}
                  renderOption={(props, option) => (
                    <li {...props} key={option.idTipoValor}>
                      {getOptionLabelTipoDeDato(option)}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("checkList.addOrEdit.dataType")}
                      variant="standard"
                      error={!!errors.idTipoValor}
                      helperText={errors.idTipoValor}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  checked={selectedOptionCheck}
                  onChange={handleCheckboxChange}
                />
                <Typography>{t("checkList.addOrEdit.requiresImage")}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Icons
                  iconName="Add"
                  fontSize="large"
                  onClick={handleChangeAgregar}
                  style={{
                    marginLeft: "auto",
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.white.main,
                  }}
                  tooltip={t("buttons.add")}
                />
              </Grid>
            </Grid>
            <Grid>
              <Paper
                sx={{
                  width: "100%",
                  margin: "auto",
                  overflow: "hidden",
                  boxShadow: "none",
                  border: "none",
                }}
              >
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }} key="icono">
                          {t("checkList.addOrEdit.action")}
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }} key="orden">
                          {t("checkList.addOrEdit.order")}
                        </TableCell>
                        <TableCell
                          style={{ fontWeight: "bold" }}
                          key="descripcionPuntoInspeccion"
                        >
                          {t("checkList.addOrEdit.inspectionPoints")}
                        </TableCell>
                        <TableCell
                          style={{ fontWeight: "bold" }}
                          key="descripcionTipoDato"
                        >
                          {t("checkList.addOrEdit.dataType")}
                        </TableCell>
                        <TableCell
                          style={{ fontWeight: "bold" }}
                          key="requiereImagen"
                        >
                          {t("checkList.addOrEdit.requiresImage")}
                        </TableCell>
                        <TableCell key="action"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowschecklistPuntoInspeccions.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={4 + 1} align="center">
                            {t("pagination.noData")}
                          </TableCell>
                        </TableRow>
                      )}
                      {rowschecklistPuntoInspeccions.map((row, index) => {
                        return (
                          <TableRow
                            key={index}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e) => handleDragOver(e)}
                            onDrop={(e) => handleDrop(e, index)}
                            onDragEnd={handleDragEnd}
                            className={draggedRow === index ? "dragging" : ""}
                          >
                            <TableCell>
                              <IconButton>
                                <UnfoldMore />
                              </IconButton>
                            </TableCell>
                            <TableCell sx={{ marginLeft: "10px" }}>
                              {row.orden !== null && row.orden !== "" ? (
                                row.orden
                              ) : (
                                <i>{t("checkList.notAvailable")}</i>
                              )}
                            </TableCell>
                            <TableCell sx={{ marginLeft: "10px" }}>
                              {row.descripcionPuntoInspeccion !== null &&
                              row.descripcionPuntoInspeccion !== "" ? (
                                row.descripcionPuntoInspeccion
                              ) : (
                                <i>{t("checkList.notAvailable")}</i>
                              )}
                            </TableCell>
                            <TableCell sx={{ marginLeft: "10px" }}>
                              {row.descripcionTipoDato !== null &&
                              row.descripcionTipoDato !== "" ? (
                                row.descripcionTipoDato
                              ) : (
                                <i>{t("checkList.notAvailable")}</i>
                              )}
                            </TableCell>
                            <TableCell sx={{ marginLeft: "10px" }}>
                              {
                              row.requiereImagen !== null &&
                              row.requiereImagen !== "" ? (
                                row.requiereImagen ? (
                                  t("buttons.yes")
                                ) : (
                                  t("buttons.no")
                                )
                              ) : (
                                <i>{t("checkList.notAvailable")}</i>
                              )}
                            </TableCell>
                            <TableCell>
                              <Icons
                                iconName="Remove"
                                fontSize="medium"
                                style={{
                                  backgroundColor: theme.palette.danger.main,
                                  color: "#fff",
                                }}
                                onClick={() => handleRemoveUnit(index)}
                                tooltip={t("buttons.remove")}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
            <Grid container justifyContent="flex-end" sx={{ marginTop: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                {t("checkList.addOrEdit.save")}
              </Button>
            </Grid>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
    </>
  );
}
